/* ============================================================
   Custom JS – Optimized for performance
   ============================================================ */
(function () {
  "use strict";

  const idle =
    window.requestIdleCallback ||
    function (cb) {
      setTimeout(cb, 200);
    };

  const ready = (fn) =>
    document.readyState !== "loading"
      ? fn()
      : document.addEventListener("DOMContentLoaded", fn);

  /* ===========================
     Back to Top (null-safe)
     =========================== */
  ready(() => {
    const btn = document.getElementById("back-to-top");
    if (!btn) return;

    const onScroll = () => {
      btn.style.display =
        (window.scrollY || document.documentElement.scrollTop) > 50
          ? "block"
          : "none";
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    btn.addEventListener("click", () =>
      window.scrollTo({ top: 0, behavior: "smooth" })
    );
    onScroll();
  });

  /* ==========================================
     Auto-open facets when ?open=filters (mobile)
     ========================================== */
  idle(() => {
    function isMobile() {
      return window.matchMedia("(max-width: 767px)").matches;
    }

    function tryOpenFilters() {
      const selectors = [
        "[data-facets-open]",
        ".facets__open",
        ".js-filter-open",
        ".mobile-facets__open",
        ".collection-filters__toggle",
        'button[aria-controls*="Facet"]',
        'button[aria-controls*="Filter"]',
        "#FacetDrawer [data-drawer-open]",
        "#FiltersDrawer [data-drawer-open]",
      ];

      for (const sel of selectors) {
        const btn = document.querySelector(sel);
        if (btn) {
          btn.click();
          return true;
        }
      }

      const drawer =
        document.getElementById("FacetDrawer") ||
        document.getElementById("FiltersDrawer");

      if (drawer) {
        drawer.setAttribute("open", "");
        drawer.classList.add("is-open", "open");
        return true;
      }

      const details = document.querySelectorAll(
        "details.facets__disclosure, details[is='facet-details'], .facets__disclosure"
      );

      if (details.length) {
        details.forEach((d) => d.setAttribute("open", "open"));

        const host = document.querySelector(
          "#FacetFiltersForm, .facets-container, .mobile-facets, .collection-filters"
        );
        if (host)
          host.scrollIntoView({ behavior: "smooth", block: "start" });

        return true;
      }

      return false;
    }

    function initOpenFilters() {
      const params = new URLSearchParams(location.search);
      if (params.get("open") !== "filters" || !isMobile()) return;

      if (tryOpenFilters()) return;

      const mo = new MutationObserver(() => {
        if (tryOpenFilters()) mo.disconnect();
      });

      mo.observe(document.documentElement, { childList: true, subtree: true });
      document.addEventListener("shopify:section:load", tryOpenFilters);
      setTimeout(tryOpenFilters, 1200);
      setTimeout(tryOpenFilters, 2500);
    }

    ready(initOpenFilters);
  });

  /* ===========================
     Bundle Add-to-Cart
     =========================== */
  window.addToCartBundle = function () {
    const color1El = document.getElementById("color1");
    const color2El = document.getElementById("color2");
    if (!color1El || !color2El) return alert("Please select both colors");

    const color1 = color1El.value;
    const color2 = color2El.value;
    if (!color1 || !color2) return alert("Please select both colors");

    const variants = window.productVariants || [];
    const variant1 = variants.find((v) => v.public_title === color1);
    const variant2 = variants.find((v) => v.public_title === color2);

    if (!variant1 || !variant2) return alert("Unable to find matching variants.");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: variant1.id,
            quantity: 1,
            properties: {
              Bundle: "1× 1-Cup + 1× 2-Cup Deal",
              "Cup Size": "1 Cup",
              Color: color1,
            },
          },
          {
            id: variant2.id,
            quantity: 1,
            properties: {
              Bundle: "1× 1-Cup + 1× 2-Cup Deal",
              "Cup Size": "2 Cup",
              Color: color2,
            },
          },
        ],
      }),
    }).then(() => (window.location.href = "/cart"));
  };

  /* ============================================================
     Move BEAST (BEST Currency Converter) into mobile menu drawer
     ============================================================ */
  idle(() => {
    const MOBILE_QUERY = "(max-width: 991px)";
    let originalParent, originalNext, remembered;

    const findAnchor = () =>
      document.querySelector(".doubly-wrapper, .doubly-wrapper-global");

    const rememberHome = (a) => {
      if (remembered) return;
      originalParent = a.parentNode;
      originalNext = a.nextSibling;
      remembered = true;
    };

    const resetStyles = (el) => {
      el.style.cssText = "";
    };

    const restore = (a) => {
      if (!originalParent) return;
      if (originalNext && originalNext.parentNode === originalParent)
        originalParent.insertBefore(a, originalNext);
      else originalParent.appendChild(a);

      resetStyles(a);
      a.classList.remove("beast-in-menu");
    };

    const target = () =>
      document.querySelector(
        "#menu-drawer .menu-drawer__navigation-container, #menu-drawer .menu-drawer__inner-container, #menu-drawer"
      );

    const move = () => {
      const a = findAnchor();
      if (!a) return;

      rememberHome(a);

      if (window.matchMedia(MOBILE_QUERY).matches) {
        const t = target();
        if (t && !t.contains(a)) {
          t.appendChild(a);
          resetStyles(a);
          a.style.margin = "12px 0";
          a.classList.add("beast-in-menu");
        }
      } else if (originalParent && a.parentNode !== originalParent) {
        restore(a);
      }
    };

    ready(move);
    document.addEventListener("shopify:section:load", move);

    const mo = new MutationObserver(move);
    mo.observe(document.documentElement, { childList: true, subtree: true });

    const mm = window.matchMedia(MOBILE_QUERY);
    // Safari fallback
    if (mm.addEventListener) mm.addEventListener("change", move);
    else if (mm.addListener) mm.addListener(move);
  });

  /* ============================================================
     Hero CTA → Filter flow
     ============================================================ */
  document.addEventListener(
    "click",
    (ev) => {
      const el = ev.target.closest(".js-filter-cta");
      if (!el) return;

      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      const url =
        el.dataset.collectionUrl || el.getAttribute("href") || "/collections/all";

      if (isMobile) {
        ev.preventDefault();
        const u = new URL(url, location.origin);
        u.searchParams.set("open", "filters");
        location.assign(u.toString());
      }
    },
    true
  );

  /* ============================================================
     Localization auto-submit
     ============================================================ */
  document.addEventListener("change", (e) => {
    const sel = e.target;
    if (!sel || !sel.closest) return;

    const form = sel.closest(
      "form.localization-form, #LocalizationHeader, #HeaderLocalization, #CountrySelectorHeader"
    );

    if (
      form &&
      sel.matches(
        'select[name="country_code"], select[name="language_code"], .localization__select'
      )
    ) {
      try {
        form.submit();
      } catch (_) {}
    }
  });

  /* ============================================================
     Unlock scroll (cart refresh fix)
     ============================================================ */
  idle(() => {
    const unlock = () => {
      document.documentElement.classList.remove(
        "lock-scroll",
        "modal-open",
        "overflow-hidden"
      );
      document.body.classList.remove("lock-scroll", "modal-open", "overflow-hidden");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };

    document.addEventListener(
      "cart:updated",
      () => {
        unlock();

        const dd = document.getElementById("cart-dropdown-bubble");
        if (!dd) return;

        dd.classList.add("show");
        clearTimeout(window.__cartDDTimer2);
        window.__cartDDTimer2 = setTimeout(() => dd.classList.remove("show"), 2000);
      },
      true
    );

    ["scroll", "touchstart", "wheel"].forEach((ev) =>
      window.addEventListener(ev, unlock, { passive: true })
    );
  });

  /* ============================================================
     Winter ’24 Helper
     ============================================================ */
  idle(() => {
    const getVar = (n) =>
      getComputedStyle(document.documentElement).getPropertyValue(n).trim();

    const hasVars = () =>
      !!(getVar("--w24-section-gradient") || getVar("--w24-accent-outline"));

    const urlForcesOn = () =>
      new URL(location.href).searchParams.get("w24") === "on";

    const flagOn = document.documentElement.getAttribute("data-w24") === "true";

    function applyW24() {
      if (!(hasVars() || flagOn || urlForcesOn())) return;

      document.documentElement.classList.add("w24-enabled");

      const grad =
        getVar("--w24-section-gradient") ||
        "linear-gradient(to right, #6D8196 0%, #A8ACB2 50%, #6D8196 100%)";

      document
        .querySelectorAll(
          '.search-by-filter-desktop[data-w24="true"][data-w24-gradient="true"]'
        )
        .forEach((el) => {
          const bg = getComputedStyle(el).backgroundImage || "";
          if (!bg.includes("gradient")) el.style.background = grad;
        });
    }

    ready(applyW24);
    document.addEventListener("shopify:section:load", applyW24);
    setTimeout(applyW24, 600);
    setTimeout(applyW24, 1600);
  });

  /* ============================================================
     Mobile search icon: open drawer/focus input instead of refresh
     ============================================================ */
  document.addEventListener(
    "click",
    function (e) {
      const a = e.target.closest('a[href*="/search"], a[href^="/search"]');
      if (!a) return;

      if (!window.matchMedia("(max-width: 768px)").matches) return;

      e.preventDefault();
      e.stopPropagation();

      const toggle =
        document.querySelector("[data-search-toggle]") ||
        document.querySelector(
          ".header__search-toggle, .search-toggle, .js-search-toggle"
        );

      if (toggle) {
        toggle.click();
        return;
      }

      const input =
        document.querySelector('input[type="search"]') ||
        document.querySelector('form[action*="/search"] input[name="q"]');

      if (input) {
        input.focus();
      } else {
        window.location.href = "/search";
      }
    },
    true
  );
})();
